import type { Resident } from '@lmc/ts-common'
import { FilterContainer } from '@lmc/ui-kit'
import type dayjs from 'dayjs'
import { NAMESPACE } from 'locale'
import { riskAssessmentReportConstants as translations } from 'locale/riskAssessmentReports'
import { useTranslation } from 'react-i18next'
import {
  StyledRangePicker
  // StyledSelect,
} from 'screens/Reports/RiskAssessmentDashboard/components/CommonStyledComponents'
// import useFormOptions from 'screens/Reports/RiskAssessmentDashboard/screens/utils/useFormOptions'
// import { escapeRegExp } from 'common/utils'
import type { PerAssessmentFilters } from 'screens/Reports/RiskAssessmentDashboard/screens/PerAssessmentScreen/components/DashboardFilters/DashboardFilters'
import type { RangeValue } from 'types/shared'

export type PerResidentFilters = {
  rangePicker?: RangeValue<dayjs.Dayjs>
  resident?: string | null
} & Pick<PerAssessmentFilters, 'riskAssessment'>

type DashboardFiltersProps = {
  value: PerResidentFilters
  onChange: (value: PerResidentFilters) => void
}

export const getName = (item: Resident) =>
  `${item?.name.first} ${item?.name.last}`

export const DashboardFilters = ({
  value,
  onChange
}: DashboardFiltersProps) => {
  const { t } = useTranslation(NAMESPACE.RISK_ASSESSMENT_REPORT)

  const handleInputChange = (
    newValue: Partial<PerResidentFilters> | Partial<PerAssessmentFilters>
  ) => {
    onChange({
      ...value,
      ...newValue
    })
  }

  // filter to be finished on BE side
  // const formOptions = useFormOptions()

  return (
    <FilterContainer title={t(translations.FILTERS)}>
      <>
        <StyledRangePicker
          format="DD MMM YYYY"
          picker="month"
          value={value.rangePicker}
          onChange={(rangePicker) => handleInputChange({ rangePicker })}
        />
        {/* <StyledSelect
          options={formOptions || []}
          showSearch
          optionFilterProp="label"
          filterOption={(input, option) =>
            option?.label.match(new RegExp(escapeRegExp(input), 'i'))
          }
          placeholder={t(translations.RISK_ASSESSMENT)}
          onChange={(riskAssessment) => {
            handleInputChange({
              riskAssessment: riskAssessment as string,
            })
          }}
        /> */}
      </>
    </FilterContainer>
  )
}

export default DashboardFilters
